// useCrossTabLogout.js
import { useEffect, useRef } from 'react';
import { TAB_ID } from './tabId'; // generate per tab using crypto or Math.random

const CHANNEL_NAME = 'session-control';

const useCrossTabLogout = (onLogout) => {
	const onLogoutRef = useRef(onLogout);
	
	// Update ref when callback changes to avoid stale closures
	useEffect(() => {
		onLogoutRef.current = onLogout;
	}, [onLogout]);

	useEffect(() => {
		console.log(`[${TAB_ID}] Setting up cross-tab logout listener`);
		const channel = new BroadcastChannel(CHANNEL_NAME);

		channel.onmessage = (event) => {
			const { type, tabId } = event.data || {};
			if (type === 'logout' && tabId !== TAB_ID) {
				console.log(`[${TAB_ID}] Cross-tab logout triggered by tab ${tabId}`);
				// Use ref to avoid stale closure and prevent dependency issues
				onLogoutRef.current?.();
			}
		};

		return () => {
			console.log(`[${TAB_ID}] Cleaning up cross-tab logout listener`);
			channel.close(); // ✅ Clean up listener when unmounting
		};
	}, []); // Empty array is OK since we use ref to access latest callback
};

export default useCrossTabLogout;

